import { render, staticRenderFns } from "./payment-method.page.vue?vue&type=template&id=13dd2aba&"
import script from "./payment-method.page.vue?vue&type=script&lang=ts&"
export * from "./payment-method.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports